module.exports = __webpack_public_path__ + "static/img/28.927082a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhmnq/28.jpg
// module id = D+xR
// module chunks = 1